/*
 * Helper constants and functions
 */

// make it easier for ourselves by putting some values in objects
// in TypeScript, these would be enums
const Keys = {
    Backspace: 'Backspace',
    Clear: 'Clear',
    Down: 'ArrowDown',
    End: 'End',
    Enter: 'Enter',
    Escape: 'Escape',
    Home: 'Home',
    Left: 'ArrowLeft',
    PageDown: 'PageDown',
    PageUp: 'PageUp',
    Right: 'ArrowRight',
    Space: ' ',
    Tab: 'Tab',
    Up: 'ArrowUp'
}

const MenuActions = {
    Close: 0,
    CloseSelect: 1,
    First: 2,
    Last: 3,
    Next: 4,
    Open: 5,
    Previous: 6,
    Select: 7,
    Space: 8,
    Type: 9
}

// filter an array of options against an input string
// returns an Map of options that begin with the filter string, case-independent
function filterOptions(options = new Map, filter, exclude = []) {
    return new Map([...options].filter(([id, label]) => {
        const matches = label.trimStart().toLowerCase().startsWith(filter.trimStart().toLowerCase());
        return matches && exclude.indexOf(label) < 0;
    }));
}

// return combobox action from key press
function getActionFromKey(event, menuOpen) {
    const { key, altKey, ctrlKey, metaKey } = event;
    // handle opening when closed
    if (!menuOpen && (key === Keys.Down || key === Keys.Enter || key === Keys.Space)) {
        return MenuActions.Open;
    }

    // handle keys when open
    if (key === Keys.Down) {
        return MenuActions.Next;
    }
    else if (key === Keys.Up) {
        return MenuActions.Previous;
    }
    else if (key === Keys.Home) {
        return MenuActions.First;
    }
    else if (key === Keys.End) {
        return MenuActions.Last;
    }
    else if (key === Keys.Escape) {
        return MenuActions.Close;
    }
    else if (key === Keys.Enter) {
        return MenuActions.CloseSelect;
    }
    else if (key === Keys.Space) {
        return MenuActions.Space;
    }
    else if (key === Keys.Backspace || key === Keys.Clear || (key.length === 1 && !altKey && !ctrlKey && !metaKey)) {
        return MenuActions.Type;
    }
}

// get index of option that matches a string
// if the filter is multiple iterations of the same letter (e.g "aaa"),
// then return the nth match of the single letter
function getIndexByLetter(options, filter) {
    const nej = new Map(options);
    const firstMatch = filterOptions(nej, filter).entries().next().value;
    const allSameLetter = (array) => array.every((letter) => letter === array[0]);
    if (firstMatch) {
        return options.findIndex(([value, label], index) =>
            (label === firstMatch[1]) && index
        );
    } else if (allSameLetter(filter.split(''))) {
        // todo: this is not working
        /*         
        const matches = [...filterOptions(nej, filter[0])];
        const matchIndex = (filter.length - 1) % matches.length;
        return options.indexOf(matches[matchIndex]); 
        */
    } else {
        return -1;
    }
}

// get updated option index
function getUpdatedIndex(current, max, action) {
    switch (action) {
        case MenuActions.First:
            return 0;
        case MenuActions.Last:
            return max;
        case MenuActions.Previous:
            return Math.max(0, current - 1);
        case MenuActions.Next:
            return Math.min(max, current + 1);
        default:
            return current;
    }
}

// check if an element is currently scrollable
function isScrollable(element) {
    return element && element.clientHeight < element.scrollHeight;
}

// ensure given child element is within the parent's visible scroll area
function maintainScrollVisibility(activeElement, scrollParent) {
    const { offsetHeight, offsetTop } = activeElement;
    const { offsetHeight: parentOffsetHeight, scrollTop } = scrollParent;

    const isAbove = offsetTop < scrollTop;
    const isBelow = (offsetTop + offsetHeight) > (scrollTop + parentOffsetHeight);

    if (isAbove) {
        scrollParent.scrollTo(0, offsetTop);
    }
    else if (isBelow) {
        scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
    }
}

export {
    MenuActions,
    filterOptions,
    getActionFromKey,
    getIndexByLetter,
    getUpdatedIndex,
    isScrollable,
    maintainScrollVisibility
}